import React from 'react';
import { useTranslation } from 'react-i18next';
import WifiTetheringOffRoundedIcon from '@mui/icons-material/WifiTetheringOffRounded';

import CommonModal from '../../../components/common-modal/CommonModal';
import BenefitList from './BenefitList';
import RequestFullAccessButton from '../request-full-access-button/RequestFullAccessButton';

import scss from './NoAttemptsModal.module.scss';

function NoAttemptsModal({ isOpen, onClose }) {
  const { t } = useTranslation('demoAdImages');

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <div className={scss.wrapper}>
        <h2 className={scss.title}>
          <WifiTetheringOffRoundedIcon />
          {t(`oopsYouAreOutOfDemoTries`)}
        </h2>

        <div className={scss.contentBlock}>
          <div className={scss.description}>
            <span>{t(`looksLikeYouveUsedAllYourAvailableDemoAttempts`)}</span>
            <span> {t(`getFullAccessToKeepGoing`)}</span>
          </div>

          <BenefitList />

          <RequestFullAccessButton />
        </div>
      </div>
    </CommonModal>
  );
}

export default NoAttemptsModal;
